import { Copy } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { copyToClipboard } from "~/common/functions";
import { Button } from "~/components/ui";
import { cn } from "~/lib/utils";

interface CopyIdsButtonProps {
  /** IDs of the currently listed items; copied to the clipboard one per line. */
  ids: string[];
  /** Button label (defaults to the generic "copy IDs"). */
  label?: string;
  className?: string;
}

/** Outline button that copies the given item IDs (one per line) to the clipboard and toasts the count. */
export function CopyIdsButton({ ids, label, className }: CopyIdsButtonProps) {
  const { t } = useTranslation();

  const onCopy = async () => {
    try {
      await copyToClipboard(ids.join("\n"));
      toast.success(t("feature.common.idsCopied", { n: ids.length }));
    } catch {
      toast.error(t("feature.common.copyToClipboardFailed"));
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className={cn(className)}
      disabled={ids.length === 0}
      onClick={onCopy}
    >
      <Copy className="size-3.5" />
      {label ?? t("feature.common.copyIds")}
    </Button>
  );
}
